<div class="content flexible-column-centered" (click)="onClickItem()" (mouseover)="mouseOver=true" (mouseout)="mouseOver=false">
    <div class="image-container fill">
        <img class="image" src="{{ isMobile ? (item.image_over ?? item.image) : (!mouseOver ? item.image : (item.image_over ?? item.image))  }}">
    </div>

    <span class="title" [ngClass]="{'text-3': !isMobile, 'text-3-small': isSmall, 'text-3-xsmall': isXSmall}">{{ item.title }}</span>
    <span class="description" [ngClass]="{'text-5': !isMobile, 'text-5-small': isSmall, 'text-5-xsmall': isXSmall}" innerHTML="{{ item.description }}"></span>
    <button class="button" [ngClass]="{'button-3': !isMobile, 'button-3-small': isSmall, 'button-3-xsmall': isXSmall}" mat-stroked-button>{{ item.button }}</button>
</div>